import React from 'react';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";

import Typography from '@material-ui/core/Typography';
import { TextField } from '@material-ui/core';

import { AppState, Actions, store } from '../../appredux'

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

import { AddItem } from '../PanelRightBasket';


type DialogChangeItemProps = {
  classes?: any,
  page?: any,
  item: any,
  close: () => void,
  open: boolean
  //open : boolean
}

class DialogChangeItem extends React.Component<DialogChangeItemProps, any> {
  stylInputaRezerwacja: React.CSSProperties = { padding: "8px 14px", textAlign: "left", fontWeight: "bold" };
  constructor(props: any) {
    super(props, {});
  }
  state = {
    changedName: this.props.item.asort_nazwa
  };




  addItem = () => {
    let menuItem = this.props.page.menuItems.find((e: any) => e.menu_id == this.props.page.selectedMenuItem)
    if (this.props.page.minItems < menuItem.zamowienie_min_ilosc_pozycji) {
      store.dispatch(Actions.pageState.setMinItems(menuItem.zamowienie_min_ilosc_pozycji));
    }
    let row = Object.create(this.props.item)
    row.asort_nazwa = this.state.changedName
    AddItem(row);


    this.props.close()
  }

  closeDialog = () => {
    this.stylInputaRezerwacja = { ...this.stylInputaRezerwacja, backgroundColor: "white" };
    this.props.close()
  }

  getText = (event: any) => {
    this.setState({ changedName: event.target.value, })
    this.stylInputaRezerwacja = { ...this.stylInputaRezerwacja, backgroundColor: "rgb(232, 240, 254)" };
  }

  //PM 2021-09-01
  //usuniecie disableBackdropClick
  render() {
    const classes = this.props.classes;

    let changedNameError = this.state.changedName == ""

    return (
      <Dialog
        disableEscapeKeyDown
        maxWidth="xs"
        open={this.props.open}
        fullWidth
      >
        <DialogTitle disableTypography>
          <Typography gutterBottom variant="h5" component="h2" color="primary" style={{ fontSize: "1.25rem" }}>
            <b>wybierz</b>
          </Typography>
          <hr style={{ marginTop: "10px" }} />
        </DialogTitle>
        <DialogContent >

          <DialogContentText className={classes.dialogContentText} style={{ paddingBottom: "5px" }}>
            <Typography gutterBottom variant="h5" component="h2" >
              {"Wpisz swój opis:"}
            </Typography>
          </DialogContentText>
          <DialogContentText className={classes.dialogContentText} style={{ paddingBottom: changedNameError ? "30px" : "10px" }}>
            {/* <Typography gutterBottom variant="h5" component="span" >
                {"   "+"nazwa asortymentu"+": "}
            </Typography> */}

            {/* <Typography component="span" color="primary" ><b>{this.props.page.ticket.data_godz_min_od}</b></Typography> */}
            <TextField
              autoFocus
              style={{ float: "right", marginTop: "-3px", width: "100%" }}
              inputProps={{ style: this.stylInputaRezerwacja }}
              InputProps={{ classes: { input: `${classes.primaryTextField}` } }}
              defaultValue={this.state.changedName}
              onChange={this.getText}
              variant="outlined"
              error={changedNameError}
              helperText={changedNameError ? "Wymagane pole" : ""}

            />
          </DialogContentText>

        </DialogContent >
        <DialogActions >
          <Button onClick={() => this.closeDialog()} variant="outlined" size="small" color="primary"
            style={{ textTransform: "none", fontSize: "0.8rem" }}
          >
            <b>anuluj</b> {/*<Trans>Back</Trans>*/}
          </Button>
          <Button onClick={() => this.addItem()} variant="contained" size="small" color="primary"
            style={{ textTransform: "none", fontSize: "0.8rem" }}
            disabled={changedNameError}
          >
            <b>ok</b>{/*<Trans>Next</Trans> */}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const styles = (theme: Theme) => ({
  primaryTextField: {
    color: theme.palette.primary.main,
    backgroundColor: "inherit",
    textAlign: 'left' as 'left',
    fontSize: "0.8rem"
  },
  dialogContentText: {
    //color: theme.palette.text.secondary,
    color: "#555",
    whiteSpace: "pre" as "pre",
    //fontSize: "14px"
  },

});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default connect(mapStateToProps)(withStyles(styles)(DialogChangeItem));